<template>
  <div class="filters__keyword-wrapper">
    <label for="keywordId" class="visuallyhidden">
      Search by Keyword
    </label>
    <input v-model="search_term"
           @keydown.enter.prevent="closeAutoComplete"
           @keydown.esc.prevent="clearKeyword"
           type="text"
           placeholder="Keyword(s)"
           class="filters__keyword-input"
           id="keywordId" />
    <div class="filters__keyword-autocomplete-results" v-click-outside="closeAutoComplete" v-if="showSuggestedResults">
      <h4>Suggested Results</h4>
      <ul class="filters__keyword-autocomplete-results__list">
        <li
          class="filters__keyword-autocomplete-results__list-item"
          v-for="(item, index) in resultsItems"
          v-if="index <= 4"
          @click="setSearchTerm(item)"
          :key="index">
          {{ item.path ? item.title : decodeURIComponent(item.url.substring(item.url.lastIndexOf('/') + 1)) | strip }}
        </li>
      </ul>
      <a href="" class="filters__keyword-autocomplete-results__see-all" @click.prevent="closeAutoComplete">See All</a>
    </div>
    <button class="filters__keyword-clear"
            aria-label="Clear keyword search"
    @click="clearKeyword">
      <svg xmlns="http://www.w3.org/2000/svg"
           width="10"
           height="10"
           viewBox="0 0 10 10"
           aria-hidden="true">
        <path fill="currentColor"
              fill-rule="evenodd"
              d="M115 8.429L113.568 7 110 10.56 106.432 7 105 8.429 108.568 11.988 105.023 15.571 106.455 17 110 13.417 113.568 17 115 15.571 111.432 11.988z"
              transform="translate(-105 -7)" />
      </svg>
    </button>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import debounce from 'tiny-debounce'

export default {
    name: 'Keyword',
    data() {
      return {
        search_term: '',
        autocompleteOpen: false,
        first_search_term: true
      }
    },
    mounted() {
      const searchString = String(window.location.search)
      const args = new URLSearchParams(searchString)
      let q = (args.has('q') ? args.get('q') : '')
      if (this.first_search_term && q !== this.search_term) {
        this.search_term = q
      }
    },
    watch: {
      search_term: debounce(function (value) {
        // Trigger autocomplete on normal query, but not on initial query.
        if(this.hasKeyword && value !== this.autocompleteTerm) {
          this.first_search_term = false
          // Added these lines in this condition to prevent double query on page load.
          this.$store.commit('updateAutocompleteTerm', value)
          if(value !== '' && value.length >= 3) {
            this.autocompleteOpen = true
          }
        }
      }, 250)
    },
    computed: {
      ...mapGetters({
        searchTerm: 'getSearchTerm',
        autocompleteTerm: 'getAutocompleteTerm',
        resultsItems: 'getAutocompleteResultsItems'
      }),
      term: {
        // getter
        get: function () {
          return this.autocompleteTerm
        },
        // setter
        set: function (newValue) {
          this.search_term = newValue
        }
      },
      showSuggestedResults() {
        return this.autocompleteOpen
          && this.autocompleteTerm.length >= 3
          && this.resultsItems.length > 0
      },
      hasKeyword() {
        return true;
      }
    },
    methods:{
      clearKeyword() {
        this.$store.commit('updateAutocompleteTerm', '')
        this.$store.commit('updateSearchTerm', '')
        this.search_term = ''
      },
      closeAutoComplete () {
        this.autocompleteOpen = false
        this.$store.commit('updateSearchTerm', this.autocompleteTerm)
      },
      isLearnuponCourse(item) {
        return item.is_learnupon_course
      },
      setSearchTerm (item) {
        if (this.isLearnuponCourse(item) && item.link) {
          window.location.assign(item.link)
          return
        }

        window.location.assign(item.path)
      },
    }
  }
</script>
<style scoped>
  .filters__keyword-autocomplete-results {
    position: absolute;
    background: #fff;
    z-index: 10;
    width: 100%;
    padding: 0.8rem;
    box-shadow: 0 2px 4px rgba(0,0,0,.08);
    margin-top: 5px;
  }

  .filters__keyword-autocomplete-results .filters__keyword-autocomplete-results__list {
    display: flex;
    flex-direction: column;
    list-style: none;
  }

  .filters__keyword-autocomplete-results .filters__keyword-autocomplete-results__list .filters__keyword-autocomplete-results__list-item {
    font-size: 1rem;
    cursor: pointer;
  }

  .filters__keyword-autocomplete-results .filters__keyword-autocomplete-results__see-all {
    font-size: 1rem;
    color: black;
  }
</style>
